var ContextCachedBy = {
  NONE: 0,
  STYLE_BIND: 1,
  PLAIN_TEXT: 2
}; // Avoid confused with 0/false.

var WILL_BE_RESTORED = 9;
exports.ContextCachedBy = ContextCachedBy;
exports.WILL_BE_RESTORED = WILL_BE_RESTORED;


//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/graphic/constant.js
// module id = 28kU
// module chunks = 9